import app from './index';

export default class HomeController {

  constructor() {

    this.anfragen = app.api.anfragen.query((success) => {
      success.forEach(a => {
        a.menge = a.artikel.sum(aa => aa.menge);
      });
    });
    this.refresh();
  }

  refresh() {
  }
}



// WEBPACK FOOTER //
// ./app/HomeController.js